
/** Mirror running emoji to face right */
const RunEmoji = () => <span aria-hidden="true" style={{ display: "inline-block", transform: "scaleX(-1)" }}>🏃</span>;

const steps = [
  { emoji: <RunEmoji />, label: "Run 2.5 km", color: "from-blue-500 to-indigo-600" },
  { emoji: "🧠", label: "5 Questions", color: "from-purple-500 to-violet-600" },
  { emoji: <RunEmoji />, label: "Run 2.5 km", color: "from-blue-500 to-indigo-600" },
  { emoji: "🧠", label: "5 Questions", color: "from-purple-500 to-violet-600" },
  { emoji: "⏱️", label: "Final Score", color: "from-orange-500 to-amber-600" },
];

export const HowItWorksSection = () => {

  return (
    <section id="how-it-works" className="py-16 md:py-24 relative bg-muted/30">
      <div className="container mx-auto px-5 md:px-8">
        {/* Section header */}
        <div className="max-w-2xl">
          <div className="text-xs font-bold uppercase tracking-widest text-brand-orange mb-2">
            How it works
          </div>
          <h2 className="text-2xl md:text-4xl font-black tracking-tight text-foreground">
            5 km of running.<br />
            <span className="text-muted-foreground">10 questions of brainpower.</span>
          </h2>
        </div>

        {/* Visual flow — horizontal on desktop, vertical on mobile */}
        <div className="mt-10">
          {/* Desktop flow */}
          <div className="hidden md:flex items-center gap-0">
            {steps.map((step, i) => (
              <div key={i} className="flex items-center">
                <div className="flex flex-col items-center gap-3 group">
                  <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${step.color} flex items-center justify-center text-2xl shadow-lg group-hover:scale-110 transition-transform`}>
                    {step.emoji}
                  </div>
                  <div className="text-sm font-bold text-foreground whitespace-nowrap">{step.label}</div>
                </div>
                {i < steps.length - 1 && (
                  <div className="mx-3 flex-shrink-0">
                    <svg width="32" height="12" viewBox="0 0 32 12" className="text-muted-foreground/30">
                      <path d="M0 6h26M22 1l5 5-5 5" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Mobile flow — vertical */}
          <div className="md:hidden flex flex-col gap-1">
            {steps.map((step, i) => (
              <div key={i} className="flex flex-col items-start">
                <div className="flex items-center gap-4">
                  <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${step.color} flex items-center justify-center text-xl shadow-md flex-shrink-0`}>
                    {step.emoji}
                  </div>
                  <div className="text-sm font-bold text-foreground">{step.label}</div>
                </div>
                {i < steps.length - 1 && (
                  <div className="ml-6 h-6 w-px bg-border" />
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Scoring card — single column, centered */}
        <div className="mt-10">
          <div className="rounded-2xl border border-border bg-card p-6 md:p-8 max-w-lg shadow-sm">
            <div className="text-xs font-bold uppercase tracking-widest text-muted-foreground mb-4">
              Scoring
            </div>
            <div className="space-y-3">
              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">Your total time (run and think)</span>
                <span className="font-mono font-bold text-foreground text-base">32:00</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">Correct answers (5 of 10)</span>
                {/* a11y: green-700 (#15803d) has 2.84:1 on dark card bg — green-400 passes at ~5.5:1 */}
                <span className="font-mono font-bold text-green-700 dark:text-green-400 text-base">− 12:30</span>
              </div>
              <div className="flex items-center justify-between rounded-xl bg-brand-orange/10 px-3 py-2.5 mt-1">
                <span className="font-bold text-foreground">Final time</span>
                <span className="font-mono font-black text-xl text-brand-orange">19:30</span>
              </div>
            </div>
            <p className="text-xs text-muted-foreground mt-4 leading-relaxed">
              Each correct answer saves 2:30 off your time. Outsmart the fast. Outrun the smart.
            </p>
          </div>


        </div>

        {/* Participation modes — 2×2 grid on mobile, inline row on desktop */}
        <div className="mt-8 grid grid-cols-2 md:flex md:flex-wrap gap-3">
          <span className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl md:rounded-full bg-green-50 dark:bg-green-950/30 text-green-700 dark:text-green-300 text-xs font-medium border border-green-200/50 dark:border-green-800/30">
            📍 In-person in parks
          </span>
          <span className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl md:rounded-full bg-gray-50 dark:bg-gray-950/30 text-gray-700 dark:text-gray-300 text-xs font-medium border border-gray-200/50 dark:border-gray-800/30">
            🌐 Remote — track your own run
          </span>
          <span className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl md:rounded-full bg-blue-50 dark:bg-blue-950/30 text-blue-700 dark:text-blue-300 text-xs font-medium border border-blue-200/50 dark:border-blue-800/30">
            <span aria-hidden="true" style={{ display: "inline-block", transform: "scaleX(-1)" }}>🏃</span> Solo or teams of 2–4
          </span>
          <span className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl md:rounded-full bg-amber-50 dark:bg-amber-950/30 text-amber-700 dark:text-amber-300 text-xs font-medium border border-amber-200/50 dark:border-amber-800/30">
            🍌 Fruits at the finish
          </span>
        </div>
      </div>
    </section>
  );
};
